import {store} from '../../redux'

export const authHeader = {headers:{
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getState().Auth.access_token}`
}}

